import { call, put, takeLeading } from 'redux-saga/effects';
import {
    FETCH_NAV_OPTIONS,
} from '../../actions/actionTypes';
import { setNavOptionsAction } from '../../actions/actionCreators';
import { GET_NAV_OPTIONS_URL } from '../../shared/api/urls';
import { apiRequest } from '../../shared/api';
import { APPLICATION_JSON, CONTENT_TYPE } from '../../shared/api/headers';

export function* getNavOptions() {
    const requestConfig = {
        headers: {
            [CONTENT_TYPE]: APPLICATION_JSON,
        },
        baseURL: `https://${window.location.host}`,
        url: GET_NAV_OPTIONS_URL,
    };

    try {
        const navOptionResponse = yield call(apiRequest, requestConfig);
        const { data } = navOptionResponse;
        yield put(setNavOptionsAction(data));
    } catch (error) {
        // this is a sub-optimal solution and will be replaced by a solution coming out of: https://movista.atlassian.net/browse/UPN-10523
        // eslint-disable-next-line no-console
        console.log(error);
    }
}

export default function* watchFetchNavOptions() {
    yield takeLeading(FETCH_NAV_OPTIONS, getNavOptions);
}
